import { Injectable, computed, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private requestCounter = signal(0);

  readonly isLoading = computed(() => this.requestCounter() > 0);

  show(): void {
    this.requestCounter.update(count => count + 1);
  }

  hide(): void {
    this.requestCounter.update(count => Math.max(0, count - 1));
  }

  reset(): void {
    this.requestCounter.set(0);
  }
}
